export default "__VITE_ASSET___Ejg_IEz__"